import { LANGUAGE } from '@/utils/constant.js'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 导入语言包信息
import enUS from './locale/en.js'
import zhCN from './locale/zh-CN.js'

// 注册i18n
Vue.use(VueI18n)

// 语言包根据语言环境分类
const messages = {
  US: enUS,
  CN: zhCN,
}

export default new VueI18n({
  locale: localStorage.getItem('LocalLang') || LANGUAGE.CHINESE, // 设置当前语言环境，默认中文简体
  messages, // 设置语言环境对应信息
})
